// extracted by mini-css-extract-plugin
export default {"container":"NameModal_container__MhgW5","input":"NameModal_input__k44F3","div1":"NameModal_div1__WOpa9","div2":"NameModal_div2__Rpj9O","div3":"NameModal_div3__3EVK9"};